import script from "./InvoiceTransactionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTransactionsRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTransactionsRow.vue?vue&type=style&index=0&id=52f6b41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f6b41e"]])

export default __exports__